import { z } from 'zod';
/**
 * Schema for Rent Manager category/priority selection response
 */
export const RentManagerIssueCategorySchema = z.object({
    categoryId: z.number().describe('The ServiceManagerCategoryID to use'),
    priorityId: z.number().describe('The ServiceManagerPriorityID to use'),
    reasoning: z
        .string()
        .describe('Brief explanation of why these were selected'),
});
/**
 * Prompt template for categorizing Rent Manager service issues
 * Used to select appropriate category and priority for work orders
 */
export const rentManagerIssueCategoryTemplate = {
    name: 'rent-manager-issue-categorization',
    version: '1.0.0',
    systemPrompt: `You are a property management assistant that categorizes maintenance issues.

Your task is to select the most appropriate category and priority for a work order based on the issue description and conversation transcript.

PRIORITY GUIDELINES:
- Default to "Low" priority for most issues
- Use "Emergency" ONLY for: water leaks, no heat in winter, gas leaks, fire damage, security emergencies, or situations that pose immediate danger to life/property
- Use "High" for urgent but non-emergency issues that need prompt attention
- Use "Medium" for issues that are inconvenient but not urgent

CATEGORY GUIDELINES:
- Select the category that best matches the type of work needed
- If unsure, default to "Maintenance" as a general category

Available Categories:
{{categoryOptions}}

Available Priorities:
{{priorityOptions}}`,
    userPrompt: `Please categorize this issue:

ISSUE SUMMARY:
{{summary}}

CONVERSATION TRANSCRIPT:
{{transcript}}`,
    variables: ['categoryOptions', 'priorityOptions', 'summary', 'transcript'],
    metadata: {
        maxTokens: 500,
        responseFormat: 'json_object',
    },
};
//# sourceMappingURL=rent-manager.js.map